import React from 'react';
import { Box, Stack, Typography, Link } from '@mui/material';
import * as COLOR from '../../../../constants/colors';
import { FAQData } from './types';

export const REFERRER_BENEFITS_ANSWER = (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 3, alignItems: "flex-start" }}>
    <Stack direction="row" spacing={3}>
      <Box
        component="img"
        src="https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/63ffe93c7d68f827c8729f9e_feature-bonus.png"
        alt="內推獎金"
        sx={{ width: 122, height: "auto" }}
      />
      <Box
        component="img"
        src="https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/63ffe93cb90b78d1d2be4ed5_feature-networking.png"
        alt="拓展人脈"
        sx={{ width: 122, height: "auto" }}
      />
      <Box
        component="img"
        src="https://cdn.prod.website-files.com/63fd958eb41ee76ac86a4ef6/63ffe93cabda12f1f60d12d6_feature-cycle.png"
        alt="正向循環"
        sx={{ width: 122, height: "auto" }}
      />
    </Stack>
    <Typography sx={{ fontSize: 18, color: COLOR.GREY3, lineHeight: 1.4, textAlign: "left", letterSpacing: 0 }}>
      內推獎金：藉由內推獎金替自己賺點小外快！（本平台無提供獎金，相關內推獎金依各公司內部規定為準）
      <br />
      拓展人脈：為自己的職涯鋪路，建立以後自己的內推人脈！
      <br />
      正向內推循環：還記得當初自己在異國他鄉找尋第一份工作的掙扎與徬徨嗎？台灣人藉由互相幫助，形成一個強大有凝聚力的海外台灣人社群！
      <br />
    </Typography>
  </Box>
);

export const REFERRER_BENEFITS_ANSWER_TEXT_ONLY = (
  <Typography sx={{ fontSize: 16, fontWeight: 400, color: COLOR.GREY3, lineHeight: 1.4, textAlign: "left", letterSpacing: "0%" }}>
    內推獎金：藉由內推獎金替自己賺點小外快！（本平台無提供獎金，相關內推獎金依各公司內部規定為準）
    <br />
    拓展人脈：為自己的職涯鋪路，建立以後自己的內推人脈！
    <br />
    正向內推循環：還記得當初自己在異國他鄉找尋第一份工作的掙扎與徬徨嗎？台灣人藉由互相幫助，形成一個強大有凝聚力的海外台灣人社群！
    <br />
  </Typography>
);

export const NEX_WORK_INTRO_ANSWER = (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
    <Typography sx={{ fontSize: 18, color: COLOR.GREY3, lineHeight: 1.4, textAlign: "left" }}>
      NEX Work 是 NEX Foundation{' '}
      <Link
        href="https://www.nexf.org/"
        sx={{
          color: COLOR.GREY1,
          fontWeight: 600,
          textDecoration: "underline",
          textUnderlineOffset: 4,
        }}
      >
        台灣未來基金會
      </Link>{' '}
      推出的內推平台。NEX Foundation 台灣未來基金會成立於2018年，為美國聯邦政府核准的 501(c)(3)
      非營利慈善新創機構。NEX 以美國西雅圖及台灣台北為據點，透過研發和經營線上的資源平台，協助海外人才在國際舞台上的職涯發展。我們希望透過此平台連結台灣各地菁英，創造團結互助的力量。
      <br />
    </Typography>
  </Box>
);

export const FAQ_DATA: FAQData = {
  0: [
    {
      question: "為什麼需要成為推薦人？",
      answer: REFERRER_BENEFITS_ANSWER
    },
    {
      question: "我想幫忙內推別人，要怎麼成為推薦人？",
      answer: "點擊右上成為推薦人按鈕，並填寫所需的個人資訊，任何人都可以成為內推者，一起幫助台灣人社群！",
    },
    {
      question: "成為推薦人後的流程？",
      answer: "成為推薦人後會透過email收到來自申請人的申請通知，藉由申請人提供的資料，推薦人可以選擇是否願意幫忙內推，後續透過各家公司內推流程進行內推。",
    },
    {
      question: "是否可以聯繫申請人？",
      answer: "可以透過申請人履歷上的聯繫方式，如email或是LinkedIn進行聯繫。",
    }
  ],
  1: [
    {
      question: "我想被內推！要怎麼使用平台？",
      answer: "註冊會員後，可以根據有興趣的公司投遞內推申請。你可以根據協助推薦人提供的資訊選擇請誰內推。推薦人會根據你提供的簡歷與投遞職位選擇是否幫你內推。只要內推申請通過，即表示協助推薦人願意幫你內推。NEX Work 平台無法強求協助推薦人幫忙內推。",
    },
    {
      question: "一次可以申請多少內推？",
      answer: "雖然在平台上找尋推薦人不限次數，但每間公司對於內推的次數與誰協助內推有不一樣的規則，應以想申請的公司為主。建議不要同時請很多推薦人幫忙內推同一職缺，因為通常同一個人與同一個職缺只能內推一次，同時請很多推薦人幫忙內推同一職缺可能會造成協助推薦人無法上傳至公司內部，最後影響到你的內推申請。",
    },
    {
      question: "請人內推我需要提供什麼資料？",
      answer: "所需資料包含：護照英文名字, 相關年資, 最高學歷, 自我介紹, 個人經驗, 是否需要公司申請簽證, 職缺連結, 以及簡歷（僅接受doc, docx, pdf格式)",
    },
    {
      question: "內推時間需要多久？",
      answer: "不一定。所有協助推薦人皆為自願協助性質，NEX Work 平台並不能強制協助推薦人的內推流程。如果許久並未收到回音，建議可以選擇請其他協助推薦人幫忙。",
    },
    {
      question: "是否可以聯繫協助推薦人？",
      answer: "如果協助推薦人在簡介上有提供個人資訊，即可透過 email 或是 LinkedIn 聯繫。",
    },
    {
      question: "如何知道我的內推有被執行？",
      answer: "如果推薦人願意協助內推，NEX Work 會寄 email 自動通知你。如果許久未得到消息，則建議找其他協助推薦人幫忙。",
    },
  ],
  2: [
    {
      question: "你們是誰？為什麼要做 NEX Work？",
      answer: NEX_WORK_INTRO_ANSWER,
    },
    {
      question: "你們會怎麼使用我的個人資料？",
      answer: "NEX Foundation 是非營利機構，我們不會擅自將會員資料提供給第三者或其他營利用途。",
    },
    {
      question: "要怎麼加入？",
      answer: "只要點擊右上方會員註冊的按鈕，並提供所需的個人資訊，任何人都可以使用內推平台。",
    },
  ],
};
